module.exports = __webpack_public_path__ + "static/kv_transparent-0ed04bc6e5691d8596e1484cfe3e9805.png";